import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { localizedStrings } from 'lib/l10n/l10n';
import { SEASON } from '../hub/data/constants';
import GameIds from '../hub/data/GameIds';

const WorkshopLocations = {
  Map: 'Workshop',
  PracticePage: 'Practice',
};

const BookertonLocations = {
  Map: 'Bookerton Map',
  Curioso: 'Backpack',
  CuriosoSelection: 'Curioso Selection',
};

const getHubSubtitle = (season, subactivity) => {
  if (season === SEASON.GRADE_4_5) {
    return WorkshopLocations[subactivity];
  }
  if (subactivity.includes('Quest')) {
    const quest = subactivity.replace(/\D+/g, '');
    return `Quest ${quest} - ${localizedStrings.questsNames[`quest${quest}`].questName}`;
  }
  return BookertonLocations[subactivity];
};

const BRANDING = 'Boost Reading';

export default () => {
  const { season } = useSelector(({ questWorkflowReducer }) => questWorkflowReducer);
  // Overall app section
  const { activity } = useSelector(({ selectedActivity }) => selectedActivity);
  // App subsection (if necessary; this is for the hub and quests only currently)
  const subactivity = useSelector(state => (
    activity === GameIds.HUB
      ? state.metaGameReducer.navigation.screen
      : null
  ));

  useEffect(() => {
    // Update document title every time the activity or subactivity changes
    switch (activity) {
      case 'loading':
        document.title = BRANDING;
        break;
      case GameIds.HUB: {
        const subtitle = getHubSubtitle(season, subactivity);
        document.title = subtitle ? `${BRANDING}: ${subtitle}` : BRANDING;
        break;
      }
      case GameIds.SKILL_SCAN:
        document.title = `${BRANDING}: Skill Scan`;
        break;
      case GameIds.TRO_BENCHMARK:
        document.title = `${BRANDING}: Benchmark`;
        break;
      case GameIds.PLACEMENT_TOOL:
      case GameIds.LETTER_SOUND_CORRESPONDENCES:
      case GameIds.REAL_WORD_READING:
      case GameIds.BLENDING:
      case GameIds.MIND_THE_GAP:
      case GameIds.SEGMENTING:
      case GameIds.SYLLABLE_DECODING:
        document.title = `${BRANDING}: Placement`;
        break;
      default: {
        const displayName = localizedStrings.gameDisplayNames[activity] ?? activity;
        document.title = `${BRANDING}: ${displayName}`;
        break;
      }
    }
  }, [activity, subactivity, season]);

  return null;
};
